document.addEventListener('DOMContentLoaded', () => {
  const stepOneSubmit = document.querySelector('#new_user input[type="submit"]');
  stepOneSubmit?.addEventListener('click', () => {
    window.analytics?.track('Button Clicked', {
      target: 'Sign Up Page 2',
      source: 'Sign Up Page 1',
    });
  });
});
